import BaseApiService from './BaseApiService'

interface CheckResponse {
  isProtected: boolean
  granted?: boolean
}

interface VerifyResponse {
  isProtected: boolean
  granted?: boolean
  token?: string
}

class SiteProtectionApiService extends BaseApiService {
  check(token: string | null): Promise<CheckResponse> {
    return this.postSilent<CheckResponse>('/v1/site-protection/check', { token })
  }

  verify(password: string): Promise<VerifyResponse> {
    return this.postSilent<VerifyResponse>('/v1/site-protection/verify', { password })
  }
}

export const siteProtectionApiService = new SiteProtectionApiService()
